export const MeToken = '@me'

export const TodayToken = '@today'

export const LAST_UPDATED_REGEX_DAYS = /^([1-9][0-9]*)days?$/

export const UPDATED_REGEX = /^<@today-([1-9][0-9]*)(d|w|m)$/
